import React, {FC, ComponentType, ReactNode} from "react"
import styled from "styled-components"
import {CSSTransition, TransitionGroup} from "react-transition-group"

import id from "@irati/utils/id"

import Feed from "./Feed"

import {StyledTransition} from "./styled/TransitionFeed"

interface TransitionTimeout {
  appear: number
  enter: number
  exit: number
}

export interface Props {
  before: ReactNode
  timeout: TransitionTimeout
  className?: string
  arr: {uuid: string}[]
  onClick?: (() => void) | null
  component?: ComponentType
  isNew?: boolean
  id?: string
}

const TransitionFeed: FC<Props> = (props) => {
  const {before, timeout, className, arr, onClick, isNew, component: Comp} = props

  const TransitionComponent = Comp as ComponentType<any>

  return (
    <StyledTransition timeout={timeout}>
      <CSSTransition classNames="transitionFeed" appear timeout={timeout}>
        <Feed id={id("", props)} isNew={isNew} className={className}>
          {before && before}
          <TransitionGroup>
            {arr.map((item, i) => (
              <CSSTransition key={item.uuid || i} classNames="transitionFeed" appear timeout={timeout}>
                <TransitionComponent id={id(`${i}`, props)} item={item} onClick={onClick} />
              </CSSTransition>
            ))}
          </TransitionGroup>
        </Feed>
      </CSSTransition>
    </StyledTransition>
  )
}

TransitionFeed.defaultProps = {
  before: null,
  timeout: {enter: 500, exit: 500, appear: 500},
  onClick: null,
  component: styled.div``,
  isNew: false,
  id: "feed"
}

export default TransitionFeed
